
import Vue from 'vue';
import WarRoomPostList from '~/components/partials/war-room/WarRoomPostList.vue';
import WarRoomTopicsListModal from '~/components/partials/war-room/WarRoomTopicsListModal.vue';
import { categoryMeta } from '~/components/partials/war-room/constants';
import { makeCanonicalUrlForPagination } from '~/components/partials/war-room/utils';
import warRoomFetchPostsMixin from '~/components/partials/war-room/warRoomFetchPostsMixin';
import { makeUrl } from '~/components/utils/browser/url';

export default Vue.extend({
  name: 'WarRoomPostsPageCatetory',
  components: {
    WarRoomPostList,
    WarRoomTopicsListModal,
  },
  mixins: [warRoomFetchPostsMixin],
  head() {
    const category = categoryMeta[this.$route.params.categorySlug];
    if (!category) return {};

    const page = this.$route.query?.page;
    const title = `${category.title}${page ? ` | Page ${page}` : ''}`;
    const description = `${category.description}${page ? ` | Page ${page}` : ''}`;
    const url = makeUrl(this.$route.path);

    return this.$seo({
      title,
      description,
      canonical: makeCanonicalUrlForPagination({ path: this.$route.path, query: this.$route.query }),
      og: {
        url,
      },
    });
  },
});
